import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../../components";
import {
  itemCategoryOptions,
  itemIncomeAccountOptions,
  itemSubCategoryOptions,
} from "../../../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";

const QuickbooksIntegration = ({
  setActiveTab,
  currentPlacement,
  editData,
}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      itemIncomeAccount: "",
      itemCategory: "",
      subCustomer: "",
      //subCustomer: "",
      lineItem: "",
      itemClass: "",
    },
    {
      itemIncomeAccount: { type: "text", required: true },
      lineItem: { type: "text", required: true },
      itemClass: { type: "text", required: true },
    },
  );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const userFormData = {
        qBIntegration: {
          itemIncomeAcc: formData.itemIncomeAccount,
          itemCategory: formData.itemCategory,
          subCustomer: formData.subCustomer,
          lineItem: formData.lineItem,
          itemClass: formData.itemClass,
        },
      };
      const uiid = fetchPerticularData?.uiid ?? "";
      const submissionData = filterEmptyValues(userFormData);
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "permanetPlacementQuickbooks",
          payload: [
            {
              type: "SET",
              value: {
                invoices: {
                  ...submissionData,
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            setActiveTab((prev) => prev + 1);
          },
        }),
      );
    } else {
      console.log("Form errors :", errors);
    }
  };
  //   useEffect(()=>{
  // const permanetPlacementQuickbooks=currentPlacement?.permanetPlacementQuickbooks;
  // if(permanetPlacementQuickbooks){
  //   handleChange("itemIncomeAccount", permanetPlacementQuickbooks?.qBIntegration?.itemIncomeAcc)
  //   handleChange("itemCategory", permanetPlacementQuickbooks?.qBIntegration?.itemCategory)
  //   handleChange("subCustomer", permanetPlacementQuickbooks?.qBIntegration?.subCustomer)
  //   handleChange("lineItem", permanetPlacementQuickbooks?.qBIntegration?.lineItem)
  //   handleChange("itemClass", permanetPlacementQuickbooks?.qBIntegration?.itemClass)
  // }
  //   },[currentPlacement])
  //   useEffect(()=>{
  //         const permanetPlacementQuickbooks=currentPlacement?.permanetPlacementQuickbooks||{};
  //        const isEmptyOrMissing =
  //         !permanetPlacementQuickbooks ||
  //         Object.keys(permanetPlacementQuickbooks).length === 0;
  //     const invoices=editData?.invoices||{};
  //       if (isEmptyOrMissing && isEditable) {
  //        handleChange("itemIncomeAccount",invoices?.qBIntegration?.itemIncomeAcc)
  //        handleChange("itemCategory",invoices?.qBIntegration?.itemCategory)
  //        handleChange("subCustomer",invoices?.qBIntegration?.subCustomer)
  //        handleChange("lineItem",invoices?.qBIntegration?.lineItem)
  //        handleChange("itemClass",invoices?.qBIntegration?.itemClass)
  //       }
  //       },[isEditable])
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "invoices.qBIntegration uiid",
            // ref: "InvDoc",
            // incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          const invoices = data?.invoices || {};
          setFetchPerticularData(data);
          handleChange(
            "itemIncomeAccount",
            invoices?.qBIntegration?.itemIncomeAcc,
          );
          handleChange("itemCategory", invoices?.qBIntegration?.itemCategory);
          handleChange("subCustomer", invoices?.qBIntegration?.subCustomer);
          handleChange("lineItem", invoices?.qBIntegration?.lineItem);
          handleChange("itemClass", invoices?.qBIntegration?.itemClass);
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };
    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    // <div className="px-8 py-5 overflow-auto min-h-[69vh]">
    <div className="px-8 py-5 overflow-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
        <div>
          <FormFieldSet
            type="select"
            title={"Item Income Account"}
            placeholder="Select Item Income Account"
            value={formData.itemIncomeAccount}
            onChange={(value) => handleChange("itemIncomeAccount", value)}
            error={errors.itemIncomeAccount}
            options={itemIncomeAccountOptions}
            showSearch
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Item Category"}
            placeholder="Select Item Category"
            value={formData.itemCategory}
            onChange={(value) => handleChange("itemCategory", value)}
            error={errors.itemCategory}
            // options={itemCategoryOptions}
            showButton
            showSearch
            // subtitle={"add Item Category"}
            options={[
              {
                label: " ",
                value: " ",
              },
            ]}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Sub-Customer"}
            placeholder="Select Sub Customer"
            value={formData.subCustomer}
            onChange={(value) => handleChange("subCustomer", value)}
            error={errors.subCustomer}
            showButton
            showSearch
            // options={itemSubCategoryOptions}
            // subtitle={"add Sub customer"}
            options={[
              {
                label: " ",
                value: " ",
              },
            ]}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Line Item"}
            placeholder="Enter Line Item"
            value={formData.lineItem}
            onChange={(value) => handleChange("lineItem", value)}
            error={errors.lineItem}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Item Class"}
            placeholder="Enter Item Class"
            value={formData.itemClass}
            onChange={(value) => handleChange("itemClass", value)}
            error={errors.itemClass}
          />
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-10">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default QuickbooksIntegration;
